import { requestUpdateUsageGuideFaqItem } from "../useUpdateUsageGuideFaqItem";
import { ReorderUsageGuideFaqItemsRequestBody } from "./reorderUsageGuideFaqItems.types";

export const requestReorderUsageGuideFaqItems = async ({
  items
}: ReorderUsageGuideFaqItemsRequestBody): Promise<void> => {
  // There is no bulk reorder endpoint for usage-guide FAQ items (unlike the
  // global FAQ), so each moved item is PATCHed on its own. Sequential on
  // purpose: a failure halfway then leaves a prefix applied rather than an
  // arbitrary subset. If lists grow past a handful of questions, ask the
  // backend for a bulk endpoint instead of widening this loop.
  for (const item of items) {
    // oxlint-disable-next-line no-await-in-loop -- serial is the point here
    await requestUpdateUsageGuideFaqItem(item);
  }
};
